var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPagination)?_c('div',{staticClass:"gl-pagination prepend-top-default"},[_c('ul',{staticClass:"pagination justify-content-center"},_vm._l((_vm.getItems),function(item,index){return _c('li',{key:index,staticClass:"page-item",class:{
        page: item.page,
        'js-previous-button': item.prev,
        'js-next-button': item.next,
        'js-last-button': item.last,
        'js-first-button': item.first,
        'd-none d-md-block': _vm.hideOnSmallScreen(item),
        separator: item.separator,
        active: item.active,
        disabled: item.disabled || item.separator,
      }},[_c('button',{staticClass:"page-link",attrs:{"type":"button"},on:{"click":function($event){return _vm.changePage(item.title, item.disabled)}}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }